import { getStates } from "src/utils/states";
import i18next from "i18next";
import { isUS } from "src/utils/account";
import { ASTERISK } from "src/constants";
import PhoneInput from "Shared/Form/Input/PhoneInput";
import DateSelector from "Shared/Form/DateSelector";
import styled from "styled-components";
import Select from "Shared/Form/Select";

const TRANSLATION_KEY = "ContinueDeal.CreditApp.EmploymentInformation";

const FormGroup = styled("div")`
    margin-bottom: 20px;

    input,
    label {
        display: block;
    }
`;

const PhoneWrapper = styled(FormGroup)`
    width: 100%;

    ${(props) => props.theme.breakpoints.up("desktop")} {
        padding-right: 2%;
        width: 32%;
    }
`;

const StartDateWrapper = styled(FormGroup)`
    width: 100;

    ${(props) => props.theme.breakpoints.up("desktop")} {
        width: 66%;

        .month-year-wrapper {
            display: flex;
            justify-content: space-between;

            input {
                width: 48.5%;
            }
        }
    }
`;

const PhoneDataGroup = styled(FormGroup)`
    ${(props) => props.theme.breakpoints.up("desktop")} {
        display: flex;
        justify-content: space-between;
        margin-bottom: 10px;
    }
`;

const StyledAddressField = styled.div`
    display: inline-block;
    vertical-align: top;
    width: 32%;
    padding-right: 2%;
`;

export const getEmploymentAddressFields = (region: string) => {
    return [
        {
            name: "workAddress",
            label: `${i18next.t(`${TRANSLATION_KEY}.workAddressLabel`)}${ASTERISK}`,
            id: "workAddress",
        },
        {
            name: "workCity",
            label: `${i18next.t(`${TRANSLATION_KEY}.workCityLabel`)}${ASTERISK}`,
            id: "workCity",
            wrapper: StyledAddressField,
        },
        {
            name: "workState",
            id: "workState",
            wrapper: StyledAddressField,
            label: isUS(region)
                ? `${i18next.t(`${TRANSLATION_KEY}.stateLabel`)}${ASTERISK}`
                : `${i18next.t(`${TRANSLATION_KEY}.provinceLabel`)}${ASTERISK}`,
            component: Select,
            inputProps: { options: getStates(region) },
        },
        {
            name: "workPostal",
            id: "workPostal",
            label: isUS(region)
                ? `${i18next.t(`${TRANSLATION_KEY}.zipCodeLabel`)}${ASTERISK}`
                : `${i18next.t(`${TRANSLATION_KEY}.postalCodeLabel`)}${ASTERISK}`,
        },
    ];
};

export const employmentPageData = [
    {
        name: "currentEmployerName",
        id: "currentEmployerName",
        label: `${i18next.t(`${TRANSLATION_KEY}.employerLabel`)}${ASTERISK}`,
    },
    {
        name: "jobTitle",
        id: "jobTitle",
        label: `${i18next.t(`${TRANSLATION_KEY}.jobTitleLabel`)}${ASTERISK}`,
    },
    {
        component: "fieldSet",
        name: "phoneStartDate",
        id: "phoneStartDate",
        wrapper: PhoneDataGroup,
        fields: [
            {
                name: "primaryWorkPhone",
                id: "primaryWorkPhone",
                component: PhoneInput,
                label: `${i18next.t(`${TRANSLATION_KEY}.primaryPhoneLabel`)}${ASTERISK}`,
                wrapper: PhoneWrapper,
            },
            {
                name: "startDate",
                id: "startDate",
                label: `${i18next.t(`${TRANSLATION_KEY}.startDateLabel`)}${ASTERISK}`,
                component: DateSelector,
                inputProps: { type: "MY", rangeStart: new Date(1920, 1, 1), rangeEnd: new Date() },
                wrapper: StartDateWrapper,
            },
        ],
    },
];
